import { Form } from "react-bootstrap";
import RequiredReactSelect from "@components/FormsV2/RequiredReactSelect/RequiredReactSelect";
import {
  CONDITION_TYPES,
  type ComparisonValueType,
  type ConditionType,
  type Operand,
} from "./types";

export interface ConditionValue {
  conditionType: ConditionType;
  conditionalValue: string;
  comparisonValue: string;
  comparisonValueType: ComparisonValueType;
}

export interface ConditionFieldsProps {
  value: ConditionValue;
  operands: Operand[];
  onChange: (patch: Partial<ConditionValue>) => void;
}

export const ConditionFields = ({
  value,
  operands,
  onChange,
}: ConditionFieldsProps): JSX.Element => {
  const isAlways = value.conditionType === "always";
  const operandOptions = operands.map((o) => ({
    value: o.slug,
    label: o.name,
  }));
  const isSelect = value.comparisonValueType === "selected_value";

  return (
    <div>
      <h3 className="rec-section-title">When does the recommendation apply?</h3>
      <Form.Check
        type="radio"
        id="applies-always"
        name="applies-when"
        label="Always"
        checked={isAlways}
        onChange={() => onChange({ conditionType: "always" })}
      />
      <Form.Check
        type="radio"
        id="applies-conditionally"
        name="applies-when"
        label="Only when"
        checked={!isAlways}
        onChange={() => onChange({ conditionType: "greater_than" })}
      />

      {!isAlways && (
        <div className="row mt-2">
          <div className="col-sm-4">
            <RequiredReactSelect
              label="Survey value or calculation"
              value={operandOptions.find(
                (o) => o.value === value.conditionalValue
              )}
              onChange={(opt: any) =>
                onChange({ conditionalValue: opt?.value ?? "" })
              }
              options={operandOptions}
              placeholder="Select…"
              required
            />
          </div>
          <div className="col-sm-3">
            <RequiredReactSelect
              label="Condition"
              value={CONDITION_TYPES.find(
                (c) => c.value === value.conditionType
              )}
              onChange={(opt: any) =>
                onChange({
                  conditionType: (opt?.value ??
                    "greater_than") as ConditionType,
                })
              }
              options={CONDITION_TYPES}
              placeholder="Pick…"
              required
            />
          </div>
          <div className="col-sm-5">
            <Form.Check
              type="radio"
              id="cmp-select"
              name="cmp-type"
              label="Select"
              checked={isSelect}
              onChange={() =>
                onChange({
                  comparisonValueType: "selected_value",
                  comparisonValue: "",
                })
              }
            />
            {isSelect && (
              <RequiredReactSelect
                label={null}
                value={operandOptions.find(
                  (o) => o.value === value.comparisonValue
                )}
                onChange={(opt: any) =>
                  onChange({ comparisonValue: opt?.value ?? "" })
                }
                options={operandOptions}
                placeholder="Survey value…"
                required
              />
            )}
            <Form.Check
              type="radio"
              id="cmp-number"
              name="cmp-type"
              label="Or type"
              checked={!isSelect}
              onChange={() =>
                onChange({ comparisonValueType: "number", comparisonValue: "" })
              }
            />
            {!isSelect && (
              <Form.Control
                type="number"
                aria-label="Comparison value"
                value={value.comparisonValue}
                onChange={(e) => onChange({ comparisonValue: e.target.value })}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConditionFields;
